(function () {
  if (window.__scCardAtcInitV6) return;
  window.__scCardAtcInitV6 = true;

  var MINI_CART_SECTION_ID = 'mini_cart';
  var syncTimer = null;
  var miniCartRefreshTimer = null;
  var inputTimers = {};
  var renderLocked = false;
  var miniCartRefreshInFlight = false;

  function getRootUrl() {
    try {
      if (window.Shopify && Shopify.routes && Shopify.routes.root) {
        return Shopify.routes.root || '/';
      }
    } catch (e) {}

    return '/';
  }

  function buildCartUrl(path) {
    var root = getRootUrl();
    if (root.charAt(root.length - 1) === '/') root = root.slice(0, -1);
    return root + path;
  }

  function toInt(value, fallback) {
    var n = parseInt(value, 10);
    return Number.isFinite(n) ? n : (fallback || 0);
  }

  function fetchCart() {
    return fetch(buildCartUrl('/cart.js'), {
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    }).then(function (res) {
      if (!res.ok) throw new Error('Failed to fetch cart');
      return res.json();
    });
  }

  /*
    FAST PATH:
    Do not request mini_cart section inside cart update.
    This keeps add/remove fast. Mini cart refresh happens in background.
  */
  function updateCartByVariant(variantId, qty) {
    var updates = {};
    updates[String(variantId)] = Math.max(0, toInt(qty, 0));

    return fetch(buildCartUrl('/cart/update.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        updates: updates
      })
    }).then(function (res) {
      if (!res.ok) throw new Error('Failed to update cart');
      return res.json();
    });
  }

  /*
    FAST PATH:
    Do not request mini_cart section inside line change.
    Mini cart section is refreshed after the successful cart update.
  */
  function changeCartLine(lineKey, qty) {
    return fetch(buildCartUrl('/cart/change.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        id: String(lineKey),
        quantity: Math.max(0, toInt(qty, 0))
      })
    }).then(function (res) {
      if (!res.ok) throw new Error('Failed to change cart line');
      return res.json();
    });
  }

  function getWrapperVariantId(wrapper) {
    if (!wrapper) return 0;

    var input = wrapper.querySelector('[data-city-card-variant-input], input[name="id"], select[name="id"]');

    var raw =
      wrapper.getAttribute('data-variant-id') ||
      wrapper.getAttribute('data-current-city-variant-id') ||
      wrapper.getAttribute('data-city-variant-id') ||
      wrapper.dataset.variantId ||
      (input && input.value) ||
      '';

    return toInt(raw, 0);
  }

  function setWrapperVariantId(wrapper, variantId) {
    if (!wrapper || !variantId) return;

    wrapper.setAttribute('data-variant-id', String(variantId));
    wrapper.dataset.variantId = String(variantId);

    var input = wrapper.querySelector('[data-city-card-variant-input], input[name="id"], select[name="id"]');
    if (input) input.value = String(variantId);
  }

  function getWrapperQty(wrapper) {
    if (!wrapper) return 0;

    var valueEl = wrapper.querySelector('.sc-card-atc__value, .sc-pdp-sticky-mini-atc__value');

    return Math.max(
      0,
      toInt(wrapper.getAttribute('data-qty') || (valueEl ? valueEl.textContent : '0') || '0', 0)
    );
  }

  function getMinQty(wrapper) {
    return Math.max(1, toInt(wrapper && wrapper.getAttribute('data-min'), 1));
  }

  function getMaxQty(wrapper) {
    var min = getMinQty(wrapper);
    var max = toInt(wrapper && wrapper.getAttribute('data-max'), 9999);
    if (max <= 0) max = 9999;
    return Math.max(min, max);
  }

  function isSoldOut(wrapper) {
    if (!wrapper) return false;

    return (
      wrapper.classList.contains('sc-card-atc--soldout') ||
      wrapper.classList.contains('is-disabled') ||
      wrapper.getAttribute('aria-disabled') === 'true'
    );
  }

  function renderAtc(wrapper, qty) {
    if (!wrapper) return;

    qty = Math.max(0, toInt(qty, 0));

    var plusBtn = wrapper.querySelector('.sc-card-atc__plus');
    var qtyWrap = wrapper.querySelector('.sc-card-atc__qty');
    var valueEls = wrapper.querySelectorAll('.sc-card-atc__value, .sc-pdp-sticky-mini-atc__value');

    valueEls.forEach(function (el) {
      el.textContent = String(qty);
    });

    wrapper.setAttribute('data-qty', String(qty));
    wrapper.setAttribute('data-state', qty > 0 ? 'qty' : 'add');

    if (qty > 0) {
      wrapper.classList.add('sc-card-atc--has-qty');
      wrapper.classList.remove('sc-card-atc--empty');

      if (qtyWrap) qtyWrap.style.display = 'flex';
      if (plusBtn) plusBtn.style.display = 'none';
    } else {
      wrapper.classList.remove('sc-card-atc--has-qty');
      wrapper.classList.add('sc-card-atc--empty');

      if (qtyWrap) qtyWrap.style.display = 'none';
      if (plusBtn) plusBtn.style.display = 'flex';
    }
  }

  function setAtcLoading(target, isLoading) {
    if (!target) return;

    var wrapper = target.closest('.sc-card-atc, [data-city-card-atc], [data-pdp-card-atc]') || target;

    wrapper.classList.toggle('is-loading', !!isLoading);

    wrapper.querySelectorAll('button').forEach(function (button) {
      if (isSoldOut(wrapper)) {
        button.disabled = true;
      } else {
        button.disabled = !!isLoading;
      }
    });
  }

  function updateCartCount(cart) {
    if (!cart || typeof cart.item_count === 'undefined') return;

    var count = cart.item_count;

    document.querySelectorAll(
      '[data-cart-count], ' +
        '[data-cart-items-count], ' +
        '.t4s-count-box, ' +
        '.cartCount, ' +
        '.js-cart-count, ' +
        '.js_cart_count, ' +
        '.cart-count-bubble span, ' +
        '.site-header__cart-count'
    ).forEach(function (el) {
      el.textContent = count;
    });

    var miniCart = document.querySelector('#t4s-mini_cart[data-cart-wrapper], #t4s-mini_cart');
    if (miniCart) {
      miniCart.setAttribute('data-ccount', String(count));
    }
  }

  function getMiniCartCurrent() {
    return document.querySelector('#t4s-mini_cart[data-cart-wrapper], #t4s-mini_cart');
  }

  function setMiniCartRefreshing(isRefreshing) {
    miniCartRefreshInFlight = !!isRefreshing;

    if (document.documentElement) {
      document.documentElement.classList.toggle('sc-mini-cart-refreshing', !!isRefreshing);
    }
  }

  function renderMiniCartHtml(html) {
    if (!html) return false;

    var current = getMiniCartCurrent();
    if (!current) return false;

    var temp = document.createElement('div');
    temp.innerHTML = html;

    var fresh =
      temp.querySelector('#t4s-mini_cart[data-cart-wrapper], #t4s-mini_cart') ||
      temp.querySelector('[data-cart-wrapper]') ||
      temp.firstElementChild;

    if (!fresh) return false;

    var wasOpen = current.getAttribute('aria-hidden') === 'false';
    var currentClass = current.getAttribute('class');

    renderLocked = true;

    current.innerHTML = fresh.innerHTML;

    if (fresh.getAttribute('data-ccount') !== null) {
      current.setAttribute('data-ccount', fresh.getAttribute('data-ccount'));
    }

    if (currentClass) {
      current.setAttribute('class', currentClass);
    }

    current.setAttribute('aria-hidden', wasOpen ? 'false' : 'true');

    window.setTimeout(function () {
      renderLocked = false;
    }, 200);

    return true;
  }

  function renderMiniCartFromSections(sections) {
    if (!sections) return false;

    var html = sections[MINI_CART_SECTION_ID] || sections.mini_cart;
    return renderMiniCartHtml(html);
  }

  function fetchMiniCartSection() {
    setMiniCartRefreshing(true);

    return fetch(getRootUrl() + '?sections=' + encodeURIComponent(MINI_CART_SECTION_ID), {
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Failed to fetch mini cart section');
        return res.json();
      })
      .then(function (sections) {
        renderMiniCartFromSections(sections);
        return sections;
      })
      .catch(function (err) {
        console.warn('Mini cart background refresh failed', err);
        return null;
      })
      .finally(function () {
        setMiniCartRefreshing(false);
      });
  }

  function scheduleMiniCartRefresh(delay) {
    window.clearTimeout(miniCartRefreshTimer);

    miniCartRefreshTimer = window.setTimeout(function () {
      fetchMiniCartSection();
    }, typeof delay === 'number' ? delay : 250);
  }

  function dispatchPrivateCartEvent(cart) {
    try {
      document.dispatchEvent(new CustomEvent('sc:cart:updated', { detail: cart }));
    } catch (e) {}

    try {
      if (window.jQuery_T4NT) {
        jQuery_T4NT(document).trigger('sc:cart:updated', [cart]);
      }
    } catch (e) {}
  }

  function syncAtcButtonsFromCart(cart) {
    if (!cart || !Array.isArray(cart.items)) return;

    var qtyByVariant = {};

    cart.items.forEach(function (item) {
      qtyByVariant[String(item.variant_id)] = item.quantity;
    });

    document.querySelectorAll('.sc-card-atc, [data-city-card-atc], [data-pdp-card-atc]').forEach(function (wrapper) {
      var variantId = getWrapperVariantId(wrapper);
      if (!variantId) return;

      renderAtc(wrapper, qtyByVariant[String(variantId)] || 0);
    });

    updateCartCount(cart);
  }

  function syncFromCart() {
    return fetchCart()
      .then(function (cart) {
        syncAtcButtonsFromCart(cart);
        return cart;
      })
      .catch(function (err) {
        console.warn('Sharbatly cart sync error', err);
      });
  }

  function scheduleSync(delay) {
    window.clearTimeout(syncTimer);

    syncTimer = window.setTimeout(function () {
      syncFromCart();
    }, typeof delay === 'number' ? delay : 180);
  }

  function commitWrapperQty(wrapper, button, nextQty) {
    if (!wrapper || wrapper.__scAtcPending) return;
    if (isSoldOut(wrapper)) return;

    var variantId = getWrapperVariantId(wrapper);
    if (!variantId) return;

    var previousQty = getWrapperQty(wrapper);
    var minQty = getMinQty(wrapper);
    var maxQty = getMaxQty(wrapper);

    nextQty = Math.max(0, toInt(nextQty, 0));
    if (nextQty > 0 && nextQty < minQty) nextQty = minQty;
    if (nextQty > maxQty) nextQty = maxQty;

    wrapper.__scAtcPending = true;

    /*
      Immediate visual feedback.
      Loader only waits for the lightweight cart update,
      not for mini-cart section rendering.
    */
    renderAtc(wrapper, nextQty);
    setAtcLoading(button || wrapper, true);

    updateCartByVariant(variantId, nextQty)
      .then(function (cartResponse) {
        updateCartCount(cartResponse);
        syncAtcButtonsFromCart(cartResponse);
        dispatchPrivateCartEvent(cartResponse);

        /*
          Background refresh. Do not block button loader.
        */
        scheduleMiniCartRefresh(120);
      })
      .catch(function (err) {
        console.warn('Sharbatly ATC update failed', err);

        renderAtc(wrapper, previousQty);
        scheduleSync(250);
      })
      .finally(function () {
        wrapper.__scAtcPending = false;
        setAtcLoading(button || wrapper, false);
      });
  }

  function handleAtcClick(event) {
    var button = event.target.closest(
      '.sc-card-atc__plus, .sc-card-atc__btn--plus, .sc-card-atc__btn--minus'
    );

    if (!button) return;

    var wrapper = button.closest('.sc-card-atc, [data-city-card-atc], [data-pdp-card-atc]');
    if (!wrapper) return;

    event.preventDefault();
    event.stopPropagation();

    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }

    var currentQty = getWrapperQty(wrapper);
    var minQty = getMinQty(wrapper);
    var nextQty = currentQty;

    var isMainAdd =
      button.classList.contains('sc-card-atc__plus') &&
      !button.classList.contains('sc-card-atc__btn--plus');

    if (isMainAdd) {
      nextQty = currentQty > 0 ? currentQty + 1 : minQty;
    } else if (button.classList.contains('sc-card-atc__btn--plus')) {
      nextQty = currentQty + 1;
    } else if (button.classList.contains('sc-card-atc__btn--minus')) {
      nextQty = Math.max(0, currentQty - 1);
    }

    commitWrapperQty(wrapper, button, nextQty);
  }

  function getMiniCartLineData(control) {
    var item = control.closest('[data-cart-item], .t4s-mini_cart__item');
    if (!item) return null;

    var input = item.querySelector('[data-action-change][data-id], input[name="updates[]"][data-id], [data-quantity-value][data-id]');
    var remove = control.closest('[data-cart-remove]');

    var lineKey = '';

    if (remove) {
      lineKey = remove.getAttribute('data-id') || remove.dataset.id || '';
    }

    if (!lineKey && input) {
      lineKey = input.getAttribute('data-id') || input.dataset.id || '';
    }

    if (!lineKey) return null;

    var currentQty = input ? toInt(input.value || input.getAttribute('data-current-qty'), 0) : 0;
    var minQty = input ? Math.max(1, toInt(input.getAttribute('min'), 1)) : 1;
    var maxQty = input ? Math.max(minQty, toInt(input.getAttribute('max'), 9999)) : 9999;
    var step = input ? Math.max(1, toInt(input.getAttribute('step'), 1)) : 1;

    return {
      item: item,
      input: input,
      lineKey: lineKey,
      currentQty: currentQty,
      minQty: minQty,
      maxQty: maxQty,
      step: step
    };
  }

  function setMiniCartItemLoading(item, isLoading) {
    if (!item) return;

    item.classList.toggle('is-loading', !!isLoading);
    item.style.pointerEvents = isLoading ? 'none' : '';

    var loader = item.querySelector('.t4s-cart-ld__bar');
    if (loader) {
      loader.hidden = !isLoading;
      loader.classList.toggle('t4s-dn', !isLoading);
    }
  }

  function optimisticUpdateMiniCartLine(lineData, nextQty) {
    if (!lineData) return;

    if (lineData.input) {
      lineData.input.value = Math.max(0, toInt(nextQty, 0));
    }

    if (nextQty <= 0) {
      lineData.item.style.opacity = '0.35';
    }
  }

  function commitMiniCartLine(lineData, nextQty) {
    if (!lineData || !lineData.lineKey || lineData.item.__scLinePending) return;

    nextQty = Math.max(0, toInt(nextQty, 0));

    if (nextQty > 0 && nextQty < lineData.minQty) nextQty = lineData.minQty;
    if (nextQty > lineData.maxQty) nextQty = lineData.maxQty;

    lineData.item.__scLinePending = true;

    optimisticUpdateMiniCartLine(lineData, nextQty);
    setMiniCartItemLoading(lineData.item, true);

    changeCartLine(lineData.lineKey, nextQty)
      .then(function (cartResponse) {
        updateCartCount(cartResponse);
        syncAtcButtonsFromCart(cartResponse);
        dispatchPrivateCartEvent(cartResponse);

        /*
          If removed, hide row immediately after successful cart response.
          Full mini-cart section refresh happens in the background.
        */
        if (nextQty <= 0 && lineData.item && lineData.item.parentNode) {
          lineData.item.remove();
        }

        scheduleMiniCartRefresh(120);
      })
      .catch(function (err) {
        console.warn('Mini cart line update failed', err);

        scheduleSync(250);
        scheduleMiniCartRefresh(250);
      })
      .finally(function () {
        lineData.item.__scLinePending = false;
        setMiniCartItemLoading(lineData.item, false);
      });
  }

  function handleMiniCartClick(event) {
    var control = event.target.closest(
      '#t4s-mini_cart [data-cart-remove], ' +
        '#t4s-mini_cart [data-quantity-selector], ' +
        '#t4s-mini_cart .t4s-quantity-selector'
    );

    if (!control) return;

    var lineData = getMiniCartLineData(control);
    if (!lineData) return;

    event.preventDefault();
    event.stopPropagation();

    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }

    var nextQty = lineData.currentQty;

    if (control.closest('[data-cart-remove]')) {
      nextQty = 0;
    } else if (control.matches('[data-increase-qty], .is--plus') || control.closest('[data-increase-qty], .is--plus')) {
      nextQty = lineData.currentQty + lineData.step;
    } else if (control.matches('[data-decrease-qty], .is--minus') || control.closest('[data-decrease-qty], .is--minus')) {
      nextQty = Math.max(0, lineData.currentQty - lineData.step);
    }

    commitMiniCartLine(lineData, nextQty);
  }

  function handleMiniCartChange(event) {
    var input = event.target.closest(
      '#t4s-mini_cart [data-action-change][data-id], #t4s-mini_cart input[name="updates[]"][data-id]'
    );

    if (!input) return;

    var lineData = getMiniCartLineData(input);
    if (!lineData) return;

    event.preventDefault();
    event.stopPropagation();

    window.clearTimeout(inputTimers[lineData.lineKey]);

    inputTimers[lineData.lineKey] = window.setTimeout(function () {
      commitMiniCartLine(lineData, toInt(input.value, lineData.currentQty));
    }, 250);
  }

  function syncWrapperVariantFromCity(wrapper) {
    if (!wrapper) return;

    var cityVariant =
      wrapper.getAttribute('data-current-city-variant-id') ||
      wrapper.getAttribute('data-city-variant-id') ||
      wrapper.getAttribute('data-variant-id') ||
      '';

    if (!cityVariant) {
      var pdpRoot = wrapper.closest('[data-city-pdp-root]');
      if (pdpRoot) {
        cityVariant =
          pdpRoot.getAttribute('data-city-current-variant-id') ||
          pdpRoot.getAttribute('data-current-city-variant-id') ||
          '';
      }
    }

    if (!cityVariant) {
      var formVariant =
        document.querySelector('[data-city-variant-select]') ||
        document.querySelector('.t4s-product__info-wrapper form[action*="/cart/add"] [name="id"]') ||
        document.querySelector('form[action*="/cart/add"] [name="id"]');

      if (formVariant && formVariant.value) {
        cityVariant = formVariant.value;
      }
    }

    if (cityVariant) {
      setWrapperVariantId(wrapper, cityVariant);
    }
  }

  function syncAllWrapperVariantsFromCity() {
    document.querySelectorAll('[data-pdp-card-atc], [data-sc-pdp-sticky-mini-atc]').forEach(function (wrapper) {
      syncWrapperVariantFromCity(wrapper);
    });
  }

  function init() {
    document.addEventListener('click', handleAtcClick, true);
    document.addEventListener('click', handleMiniCartClick, true);
    document.addEventListener('change', handleMiniCartChange, true);

    syncAllWrapperVariantsFromCity();
    scheduleSync(80);

    document.addEventListener('city:changed', function () {
      setTimeout(function () {
        syncAllWrapperVariantsFromCity();
        scheduleSync(120);
      }, 160);
    });

    document.addEventListener('variant:changed', function () {
      setTimeout(function () {
        syncAllWrapperVariantsFromCity();
        scheduleSync(120);
      }, 120);
    });

    document.addEventListener('variant:change', function () {
      setTimeout(function () {
        syncAllWrapperVariantsFromCity();
        scheduleSync(120);
      }, 120);
    });

    document.addEventListener('change', function (event) {
      if (event.target && event.target.matches('[data-city-variant-select], form[action*="/cart/add"] [name="id"]')) {
        setTimeout(function () {
          syncAllWrapperVariantsFromCity();
          scheduleSync(120);
        }, 80);
      }
    });

    /*
      Avoid listening to cart:updated / t4s:cart:updated here.
      This prevents event loops and blinking.
    */
    document.addEventListener('shopify:section:load', function () {
      setTimeout(function () {
        syncAllWrapperVariantsFromCity();
        scheduleSync(120);
      }, 80);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.scMiniAtcSyncFromCart = syncFromCart;

  window.ScUnifiedAtc = {
    syncFromCart: syncFromCart,
    renderAtc: renderAtc,
    updateCartByVariant: updateCartByVariant,
    changeCartLine: changeCartLine,
    refreshMiniCart: fetchMiniCartSection,
    scheduleMiniCartRefresh: scheduleMiniCartRefresh
  };
})();